import React from 'react';
import { useBMP } from '../context/BMPContext';
import { useTranslation } from 'react-i18next';
import './BMPSidebar.css';

export default function BMPSidebar({ open, onClose }) {
  const { t } = useTranslation();
  const { profile, isProducer, bmpView, bmpNavigate } = useBMP();

  const nav = (view) => {
    bmpNavigate(view);
    onClose();
  };

  const isActive = (view) => bmpView === view ? 'bmp-nav-item active' : 'bmp-nav-item';

  return (
    <>
      {open && <div className="bmp-sidebar-overlay" onClick={onClose} />}
      <aside className={`bmp-sidebar${open ? ' bmp-sidebar--open' : ''}`}>
        {profile && (
          <div className="bmp-sidebar-profile">
            <div className="bmp-sidebar-greeting">
              {t('bmp_hello')}, <strong>{profile.company_name || profile.username}</strong>
            </div>
            <span className={`bmp-sidebar-role bmp-role--${profile.role}`}>
              {profile.role_display}
            </span>
          </div>
        )}

        <nav className="bmp-sidebar-nav">
          <div className="bmp-nav-section">{t('bmp_nav_market')}</div>
          <button className={isActive('catalog')} onClick={() => nav('catalog')}>
            <span className="bmp-nav-icon">&#128722;</span>
            {t('bmp_catalog')}
          </button>

          {isProducer && (
            <>
              <div className="bmp-nav-section">{t('bmp_nav_my_business')}</div>
              <button className={isActive('farms')} onClick={() => nav('farms')}>
                <span className="bmp-nav-icon">&#127793;</span>
                {t('bmp_my_farms')}
              </button>
              <button className={isActive('my_quotas')} onClick={() => nav('my_quotas')}>
                <span className="bmp-nav-icon">&#128230;</span>
                {t('bmp_my_quotas')}
              </button>
              <button className={isActive('received_bids')} onClick={() => nav('received_bids')}>
                <span className="bmp-nav-icon">&#128172;</span>
                {t('bmp_received_bids')}
              </button>
            </>
          )}

          {!isProducer && profile && (
            <>
              <div className="bmp-nav-section">{t('bmp_nav_my_business')}</div>
              <button className={isActive('my_bids')} onClick={() => nav('my_bids')}>
                <span className="bmp-nav-icon">&#128172;</span>
                {t('bmp_my_bids')}
              </button>
            </>
          )}

          {profile && (
            <>
              <div className="bmp-nav-section">{t('bmp_nav_history')}</div>
              <button className={isActive('transactions')} onClick={() => nav('transactions')}>
                <span className="bmp-nav-icon">&#128203;</span>
                {t('bmp_transactions')}
              </button>
            </>
          )}

          <div className="bmp-nav-section">{t('bmp_nav_account')}</div>
          <button className={isActive('analytics')} onClick={() => nav('analytics')}>
            <span className="bmp-nav-icon">&#128200;</span>
            {t('bmp_analytics')}
          </button>
          <button className={isActive('profile')} onClick={() => nav('profile')}>
            <span className="bmp-nav-icon">&#9881;</span>
            {t('bmp_my_profile')}
          </button>
        </nav>
      </aside>
    </>
  );
}
